/**
 * Reads fake cart product metadata from data-fake-cart-* attributes.
 * Syncs PDP submit button when the selected variant changes.
 */
(function () {
  if (!window.FakeCart) return;

  function readFromElement(el) {
    if (!el?.dataset?.fakeCartVariantId) return null;

    return {
      id: el.dataset.fakeCartVariantId,
      product_id: el.dataset.fakeCartProductId || null,
      title: el.dataset.fakeCartTitle || "",
      variant_title: el.dataset.fakeCartVariantTitle || "",
      price: parseInt(el.dataset.fakeCartPrice, 10) || 0,
      compare_at_price: parseInt(el.dataset.fakeCartCompareAtPrice, 10) || 0,
      image: el.dataset.fakeCartImage || "",
      url: el.dataset.fakeCartUrl || "",
      handle: el.dataset.fakeCartHandle || "",
    };
  }

  function findMetadataSource(el) {
    let node = el;
    while (node && node !== document.body) {
      if (node.dataset?.fakeCartVariantId) return node;
      node = node.parentElement;
    }
    return null;
  }

  function readMetadata(el) {
    const source = findMetadataSource(el);
    return source ? readFromElement(source) : null;
  }

  function getVariantsMap(productForm) {
    const script = productForm.querySelector("[data-fake-cart-variants]");
    if (!script) return null;

    try {
      const list = JSON.parse(script.textContent);
      const map = {};
      list.forEach((variant) => {
        map[String(variant.id)] = variant;
      });
      return map;
    } catch {
      return null;
    }
  }

  function applyVariantToButton(button, variant) {
    button.dataset.fakeCartVariantId = String(variant.id);
    button.dataset.fakeCartPrice = String(variant.price);
    button.dataset.fakeCartVariantTitle = variant.title || "";
    const compareAt =
      variant.compare_at_price && variant.compare_at_price > variant.price ? variant.compare_at_price : 0;
    button.dataset.fakeCartCompareAtPrice = String(compareAt);
    if (variant.image) button.dataset.fakeCartImage = variant.image;
  }

  function syncPdpSubmitButton(form) {
    const productForm = form.closest("product-form");
    if (!productForm) return;

    const button = form.querySelector(
      '[type="submit"][name="add"], [type="submit"].shop-add-to-cart-button, [type="submit"].product-form__submit',
    );
    const variantInput = form.querySelector('[name="id"]');
    if (!button || !variantInput?.value) return;

    const map = getVariantsMap(productForm);
    if (!map) return;

    const variant = map[String(variantInput.value)];
    if (variant) applyVariantToButton(button, variant);
  }

  function bindPdpForm(form) {
    if (form.dataset.fakeCartBound === "true") return;
    form.dataset.fakeCartBound = "true";

    syncPdpSubmitButton(form);

    const variantInput = form.querySelector('[name="id"]');
    if (!variantInput) return;

    variantInput.addEventListener("change", () => syncPdpSubmitButton(form));

    new MutationObserver(() => syncPdpSubmitButton(form)).observe(variantInput, {
      attributes: true,
      attributeFilter: ["value"],
    });
  }

  function initPdpSync() {
    document.querySelectorAll('product-form form[data-type="add-to-cart-form"]').forEach(bindPdpForm);

    document.addEventListener("variant:change", (event) => {
      const variantId = event.detail?.variant?.id;
      if (!variantId) return;

      document.querySelectorAll('product-form form[data-type="add-to-cart-form"]').forEach((form) => {
        const variantInput = form.querySelector('[name="id"]');
        if (variantInput && String(variantInput.value) === String(variantId)) {
          syncPdpSubmitButton(form);
        }
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initPdpSync);
  } else {
    initPdpSync();
  }

  window.FakeCartMetadata = {
    readFromElement,
    findMetadataSource,
    readMetadata,
    syncPdpSubmitButton,
  };
})();
